export const DEFAULT_TEXTS = {
  searchTitle: `Annosjakelun tuotetiedot`,
  searchDescription: ``,
  searchPlaceholder: `Hae tuotetieto`,
  searchInstruction: `Voit hakea VNR-tuotenumerolla, lääkkeen nimellä, vaikuttavalla
    aineella, värillä tai merkinnöillä. Voit hakea myös QR-koodilla
    puhelimesi avulla.`,
  footerCompany: `Yliopiston apteekki`,
  footerDescription: `Annosjakelun asiakaspalvelu avoinna arkisin klo 8.00 - 16.00`,
  footerPhone: `09 5420 4496`,
  footerQueueInfo: `pvm/mpm, jonotus pvm/mpm`,
  footerCopyright: `Copyright © 2017 Yliopiston apteekki`,
}



// WEBPACK FOOTER //
// ./src/common/constants.js